import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { type FC, memo } from 'react';

type IconVariant = 'light' | 'white' | 'colored' | 'dark';

interface Props {
  variant: IconVariant;
}

const mainPathFill: { [Variant in IconVariant]: string } = {
  light: '#B8C7CE',
  white: '#FFF',
  colored: '#FFF',
  dark: '#323232',
};

const leftCircleStroke: { [Variant in IconVariant]: string } = {
  light: '#B8C7CE',
  white: '#FFF',
  colored: '#66B2FF',
  dark: '#323232',
};

const leftCircleFill: { [Variant in IconVariant]: string } = {
  light: 'none',
  white: 'none',
  colored: '#66B2FF',
  dark: '#323232',
};

const rightCircleStroke: { [Variant in IconVariant]: string } = {
  light: '#B8C7CE',
  white: '#FFF',
  colored: '#DD4B39',
  dark: '#323232',
};

const rightCircleFill: { [Variant in IconVariant]: string } = {
  light: 'none',
  white: 'none',
  colored: '#DD4B39',
  dark: '#323232',
};

const BareCompareSnapshotsIcon: FC<SvgWrapperProps & Props> = ({
  variant,
  ...props
}) => (
  <SvgWrapper height='20' viewBox='0 0 20 20' width='20' {...props}>
    {}
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      fill={mainPathFill[variant]}
      d='M9,17.97h1V2H9V17.97z M4,6H3v4h2v4h1v-4h2V9H4V6z M15,6v3h-4v1h2v4h1v-4h2V6H15z'
    />
    <circle
      cx='3.5'
      cy='4.5'
      r='2'
      stroke={leftCircleStroke[variant]}
      fill={leftCircleFill[variant]}
    />
    <circle
      cx='5.5'
      cy='15.5'
      r='2'
      stroke={leftCircleStroke[variant]}
      fill={leftCircleFill[variant]}
    />
    <circle
      cx='15.5'
      cy='4.5'
      r='2'
      stroke={rightCircleStroke[variant]}
      fill={rightCircleFill[variant]}
    />
    <circle
      cx='13.5'
      cy='15.5'
      r='2'
      stroke={rightCircleStroke[variant]}
      fill={rightCircleFill[variant]}
    />
  </SvgWrapper>
);
export const CompareSnapshotsIcon = memo(BareCompareSnapshotsIcon);
